import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

export const StyledInnerBanner = styled.section`
    padding-top: calc(560 / 1366 * 100%);
    position: relative;
    background-color: #DDD;

    &.forImageScroll {
        //padding-top: calc(560 / 1366 * 100%);
    }

    @media (max-width: 992px) and (min-width: 768px) {
        &.for_projects {
            padding-top: calc(671 / 1366 * 100%);

        }
        padding-top: calc(760 / 1366 * 100%);


    }

	


    &:after {
        content: '';
        position: absolute;
        background: #0000007A;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
    }

    &.for_projects {
        .container {
            bottom: unset;
            top: 50%;
            transform: translateY(-50%);
            text-align: center;

            .col-md-8 {
                flex: 0 0 100%;
                width: 100%;
                text-align: center;
            }
        }
    }

	&.tech-showcase{
		.container{
            bottom: 90px;
			
		}
	}
    .container {
        position: absolute;
        //height: 100%;
        //top: 0;
        margin: auto;
        left: 0;
        right: 0;
        bottom: 40px;
        z-index: 2;
        padding-top: 40px;

        &:after {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            height: 1px;
            width: calc(100% - 30px);
            background: white;
            content: '';
			margin: 0 auto;

        }

        .breadcrumb-ygen {
            display: flex;
            gap: 10px;

            li {
                font-size: 1rem; /* 16px / 16 */
                font-style: normal;
                font-weight: 500;
                line-height: 1.5rem; /* 24px / 16 */
                color: rgba(255, 255, 255, 0.5);

                a {
                    font-size: 1rem; /* 16px / 16 */
                    font-style: normal;
                    font-weight: 500;
                    line-height: 1.5rem; /* 24px / 16 */
                    color: rgba(255, 255, 255, 0.5);

                }

                h1 {
                    font-size: 1rem; /* 16px / 16 */
                    font-style: normal;
                    font-weight: 500;
                    line-height: 1.5rem; /* 24px / 16 */
                    color: white;

                }
            }
        }


        p {
            color: ${theme.colors.white};
            margin: 0;
            font-size: 2rem;        /* 32px / 16 */
            font-style: normal;
            font-weight: 400;
            line-height: 2.25rem;   /* 36px / 16 */
			i{
                font-family: "PP Migra Italic";
                font-size: 2rem;         /* 32px / 16 */
                font-style: italic;
                font-weight: 400;
                line-height: 2.25rem;    /* 36px / 16 */
			}
        }
    }


    @media (max-width: 767px) {
        padding-top: calc(560 / 450 * 100%);

        .d-flex {
            margin: 20px 0 0 !important;
            justify-content: flex-start !important;
        }
    }

`;
